// import clientinfo from "../assets/images/sidebar/clientinfo.png";
// import clientinfowhite from "../assets/images/sidebar/clientinfowhite.png";
import chatIcon from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/chats-icon.png";
import clientinfo from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/client-info-icon.png";
import clientinfowhite from "../assets/images/Sidebar_Icons/ZCLIENT_INFORMATION.png";
import dashboard from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/dashboard-icon.png";
import dashboardwhite from "../assets/images/Sidebar_Icons/ZDASHBOARD.png";
import organizer from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/organizer-icon.png";
import organizerwhite from "../assets/images/Sidebar_Icons/ZORGANIZER.png";
import planner from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/planner-icon.png";
import plannerwhite from "../assets/images/Sidebar_Icons/ZPLANNER.png";
import protector from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/protector-icon.png";
import protectorwhite from "../assets/images/Sidebar_Icons/ZPROTECTOR.png";
import report from "../assets/images/Sidebar_Icons/reports.svg";
import reportwhite from "../assets/images/Sidebar_Icons/reports.svg";
import discountImg from "../assets/images/sidebar/discount-svgrepo-com.png";
import discountImgWhite from "../assets/images/sidebar/discount-white.png";
import faqImg from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/faq-support.png";
import faqImgWhite from "../assets/images/Sidebar_Icons/ZFAQ.png";
import secureImg from "../assets/images/sidebar/secure.png";
import notificationImg from "../assets/images/sidebar/notification.png";
import subscribeImg from "../assets/images/sidebar/add.png";
import userImg from "../assets/images/sidebar/user.png";
import rewardImg from "../assets/images/sidebar/reward.png";
import payemntImg from "../assets/images/sidebar/payemnt.png";
import settingImg from "../assets/images/sidebar/setting.png";
import settingwhiteImg from "../assets/images/sidebar/settingWhite.png";
import clienttax from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/link-bank-icon.png";
import clienttaxwhite from "../assets/images/Sidebar_Icons/TAXES_AND_INFLATION.png";
import clientLinkBankWhite from "../assets/images/Sidebar_Icons/ZLINK_BANK.png";

import linkimg from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/securelink-icon.png";
import linkimgWhite from "../assets/images/Sidebar_Icons/SOCIAL_SECURITY.png";

import feedbackImg from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/feedback.png";
import feedbackwhiteImg from "../assets/images/Sidebar_Icons/ZFEEDBACK.png";

import securewhiteImg from "../assets/images/sidebar/securewhite.png";
import notificationwhiteImg from "../assets/images/sidebar/notificationwhite.png";
import subscribewhiteImg from "../assets/images/sidebar/addwhite.png";
import userwhiteImg from "../assets/images/sidebar/userwhite.png";
import rewardwhiteImg from "../assets/images/sidebar/rewardwhite.png";
import payemntwhiteImg from "../assets/images/sidebar/paymentwhite.png";

import deletgateAccessSettings from "../assets/images/sidebar/social.png";
import deletgateAccessSettingsWhite from "../assets/images/sidebar/socialwhite.png";

// client- tab
import clientconwhite from "../assets/images/Sidebar_Icons/CLIENT_CONTACTS.png";
import clientcon from "../assets/images/sidebar/clientcon.png";
import clientplan from "../assets/images/sidebar/clientplan.png";
import clientplanwhite from "../assets/images/sidebar/clientplanswhite.png";
import clientreturn from "../assets/images/sidebar/clientreturns.png";
import clientreturnwhite from "../assets/images/Sidebar_Icons/RATES_OF_RETURN.png";
import clientcustom from "../assets/images/sidebar/clientcustom.png";
import clientcustomwhite from "../assets/images/sidebar/clientcustomwhite.png";
import clientmobile from "../assets/images/sidebar/clientMobile.png";
import clientmobliewhite from "../assets/images/sidebar/clientmobileWhite.png";

// orgainzer tab
import liability from "../assets/images/sidebar/liabilties.png";
import liabilitywhite from "../assets/images/Sidebar_Icons/LIABILITIES.png";
import assets from "../assets/images/sidebar/assets.png";
import assetswhite from "../assets/images/Sidebar_Icons/ASSETS.png";
import income from "../assets/images/sidebar/income.png";
import incomewhite from "../assets/images/Sidebar_Icons/SOURCES_OF_INCOME.png";
import insurance from "../assets/images/sidebar/insurance.png";
import insurancewhite from "../assets/images/Sidebar_Icons/INSURANCE.png";
import budget from "../assets/images/sidebar/budget.png";
import budgetwhite from "../assets/images/Sidebar_Icons/BUDGET.png";
import assistance from "../assets/images/sidebar/assistance.png";
import assistancewhite from "../assets/images/sidebar/assistancewhite.png";

// planner tab
import debt from "../assets/images/sidebar/debt.png";
import debtwhite from "../assets/images/Sidebar_Icons/DEBT_PAYOFF.png";
import social from "../assets/images/sidebar/social.png";
import socialwhite from "../assets/images/Sidebar_Icons/SOCIAL_SECURITY.png";
import goals from "../assets/images/sidebar/goals.png";
import goalswhite from "../assets/images/Sidebar_Icons/GOALS.png";

// protector tab
import disability from "../assets/images/sidebar/disability.png";
import disabilitywhite from "../assets/images/Sidebar_Icons/DISABILITY.png";
import divorce from "../assets/images/sidebar/divorce.png";
import divorcewhite from "../assets/images/Sidebar_Icons/DIVORCE.png";
import death from "../assets/images/sidebar/death.png";
import deathwhite from "../assets/images/sidebar/death.png";
import deathModule from "../assets/images/sidebar/deathModule.png";
import deathModulewhite from "../assets/images/sidebar/deathmodulewhite.png";
import disaster from "../assets/images/sidebar/disaster.png";
import disasterwhite from "../assets/images/Sidebar_Icons/DISASTER.png";
import owners from "../assets/images/sidebar/owners.png";

export const getSideItemsClient = () => {
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  const duplicateUserRole =
    localStorage.getItem("duplicateRole") !== "undefined" &&
    JSON.parse(localStorage.getItem("duplicateRole"));
  const sideItemsClient = [
    {
      href: "/dashboard",
      title: "Dashboard",
      image: dashboard,
      whiteImage: dashboardwhite,
      permission: ["Super Admin", "StoreDebtData", "FetchExpenses"],
    },
    {
      href: "/client_info",
      title: "Client Information",
      image: clientinfo,
      whiteImage: clientinfowhite,
      permission: ["Super Admin", "List All Cloud Contacts"],

      subNav: [
        // {
        //   title: "Clients and Plans",
        //   path: "/client/plan",
        //   image: clientplan,
        //   cName: "sub-nav",
        //   whiteImage: clientplanwhite,
        //   permission: ["Super Admin", "List All Cloud Contacts"],
        // },
        {
          title: "Client Contacts",
          path: "/client/plan",
          cName: "sub-nav",
          image: clientcon,
          whiteImage: clientconwhite,
          permission: ["Super Admin", "List All Cloud Contacts"],
        },
        // {
        //   title: "Mobile Sync",
        //   path: "/dashboard1",
        //   image: clientmobile,
        //   cName: "sub-nav",
        //   whiteImage: clientmobliewhite,
        //   permission: ["Super Admin"],
        // },
        {
          title: "Tax and Inflation",
          path: "/tax_inflation",
          image: clienttax,
          whiteImage: clienttaxwhite,
          permission: ["Super Admin", "FetchTaxAndInflation"],
        },
        {
          title: "Rates of Return",
          path: "/rates_of_return",
          image: clientreturn,
          whiteImage: clientreturnwhite,
          permission: ["Super Admin", "FetchRatesOfReturn"],
        },
        // {
        //   title: "Client Contacts",
        //   path: "/client_contacts",
        //   image: clientcon,
        //   whiteImage: clientconwhite,
        //   permission: ["Super Admin"],
        // },
        // {
        //   title: "Custom Components",
        //   path: "/custom_components",
        //   image: clientcustom,
        //   whiteImage: clientcustomwhite,
        //   permission: ["Super Admin"],
        // },
      ],
    },
    {
      href: "/organizer",
      title: "Organizer",
      image: organizer,
      whiteImage: organizerwhite,
      permission: [
        "asset allocation",
        "Create Client's Accounts Assets",
        "Fetch Client's Accounts Assets",
        "Delete Client's Accounts Assets",
        "Super Admin",
      ],

      subNav: [
        {
          title: "Assets",
          path: "/assets",
          image: assets,
          cName: "sub-nav",
          whiteImage: assetswhite,
          permission: [
            "asset allocation",
            "Create Client's Accounts Assets",
            "Fetch Client's Accounts Assets",
            "Delete Client's Accounts Assets",
            "Update Clients's Account Asset",
            "client module list",
            "attribute detail",
            "create client module",
            "Calculate Budget",
            "Create Transaction",
            "Create Category",
            "Create Budget",
            "Get Transactions",
            "Super Admin",
          ],
        },
        {
          title: "Liabilities and Credit",
          path: "/liabilities_credit",
          image: liability,
          whiteImage: liabilitywhite,
          permission: ["create client module", "Super Admin"],
        },
        // {
        //   title: "Insurance",
        //   path: "/insurance",
        //   image: insurance,
        //   cName: "sub-nav",
        //   whiteImage: insurancewhite,
        //   permission: ["Super Admin"],
        // },
        {
          title: "Insurance",
          path: "/organizer/insurance",
          image: insurance,
          cName: "sub-nav",
          whiteImage: insurancewhite,
          permission: ["create client module", "Super Admin"],
        },
        {
          title: "Sources of Income",
          path: "/income",
          image: income,
          whiteImage: incomewhite,
          permission: ["Super Admin", "create client module"],
        },
        // {
        //   title: "Assistance",
        //   path: "/assistance/create",
        //   image: assistance,
        //   cName: "sub-nav",
        //   whiteImage: assistancewhite,
        //   permission: ["Super Admin"],
        // },
        {
          title: "Budget",
          path: "/budget",
          image: budget,
          whiteImage: budgetwhite,
          permission: [
            "Super Admin",
            "Calculate Budget",
            "Get Transactions",
            "Create Transaction",
            "Create Category",
            "Create Budget",
          ],
        },
        {
          title: "Important Document",
          path: "/orgainzer/important-document",
          image: clientinfowhite,
          whiteImage: clientinfowhite,
          permission: ["Super Admin", "FetchImpDocument"],
        },
      ],
    },
    {
      href: "/planner",
      title: "Planner",
      image: planner,
      whiteImage: plannerwhite,
      permission: ["Fetch Payoff", "FetchGoalsDetail", "Super Admin"],

      subNav: [
        {
          title: "Debt Payoff",
          path: "/debt-payOff",
          // path: "/debt/create",
          image: debt,
          cName: "sub-nav",
          whiteImage: debtwhite,
          permission: ["Fetch Payoff", "Super Admin"],
        },
        {
          title: "Social Security",
          path: "/planner/social-security",
          image: social,
          whiteImage: socialwhite,
          permission: ["Fetch Payoff", "Super Admin"],
        },
        {
          title: "Goals",
          path: "/goals",
          image: goals,
          cName: "sub-nav",
          whiteImage: goalswhite,
          permission: ["Super Admin", "FetchGoalsDetail"],
        },
      ],
    },
    {
      href: "/protector",
      title: "Protector",
      image: protector,
      whiteImage: protectorwhite,
      permission: [
        "Confirm Death",
        "Get Client Death Url",
        "Send Otp in Death Module",
        "Revert Death Status",
        "Cleint Death Status",
        "Create Death Status Revert Time",
        "Send Emails And Text In Death Module",
        "Save Client Death Url",
        "Super Admin",
      ],

      subNav: [
        {
          title: "Death (When I Die)",
          path: "/protector/death/dashboard",
          whiteImage: deathwhite,
          image: death,
          permission: [
            "Confirm Death",
            "Get Client Death Url",
            "Send Otp in Death Module",
            "Revert Death Status",
            "Cleint Death Status",
            "Create Death Status Revert Time",
            "Send Emails And Text In Death Module",
            "Save Client Death Url",
            "Super Admin",
          ],
        },
        {
          title: "Disability",
          path: "/protector/disability/dashboard",
          image: disability,
          whiteImage: disabilitywhite,
          cName: "sub-nav",
          permission: ["Super Admin", "create client module"],
        },
        {
          title: "Divorce",
          path: "/protector/divorce/dashboard",
          image: divorce,
          whiteImage: divorcewhite,
          cName: "sub-nav",
          permission: ["Super Admin", "create client module"],
        },
        {
          title: "Disaster",
          path: "/protector/disaster/dashboard",
          whiteImage: disasterwhite,
          image: disaster,
          permission: ["Super Admin", "create client module"],
        },
      ],
    },
    {
      href: "/reports",
      title: "Reports",
      image: report,
      whiteImage: reportwhite,
      permission: [
        "Super Admin",
        "Calculate Budget",
        "Get Transactions",
        "Create Transaction",
        "Create Category",
        "Create Budget",
      ],
    },
    // {
    //   href: "/schedules",
    //   title: "Reports & Schedule",
    //   image: report,
    //   whiteImage: reportwhite,
    //   permission: ["Super Admin"],
    // },
    {
      href: "/secureLink",
      title: "Manage Secure Links",
      image: linkimg,
      whiteImage: linkimgWhite,
      permission: [
        "Document Share",
        "Get Document Share",
        "Delete Document Share",
        "Super Admin",
      ],
    },
    {
      href: "/plaid",
      title: "Link Bank",
      image: clienttax,
      whiteImage: clientLinkBankWhite,
      permission: ["Store Account Details", "Super Admin"],
    },
    {
      href: "/chats",
      title: "Chat",
      image: chatIcon,
      whiteImage: chatIcon,
      permission: ["Super Admin", "sendMessage"],
    },
    // {
    //   href: "/thirdPartyResources",
    //   title: "Third Party Resources",
    //   image: discountImg,
    //   whiteImage: discountImgWhite,
    //   permission: ["Super Admin"],
    // },
    {
      // href: "https://whenidie.com/#faq",
      href: "https://help.assetplanet.com/",
      // href: "https://assets-planet.s3.amazonaws.com/media/4ccc9cd8-f156-44c3-9c19-d4aa9a45811a.docx", for file download
      title: "FAQ Help Support",
      image: faqImg,
      whiteImage: faqImgWhite,
      permission: ["Super Admin", "Get ME"],
    },
    {
      href: "/feedback",
      title: "Feedback",
      image: feedbackImg,
      whiteImage: feedbackwhiteImg,
      permission: ["Client Feedback", "Super Admin"],
    },
  ];
  const userRoles = ['Financial Advisor', 'Active Financial Advisor']
  if (
    userRoles.includes(userRole) ||
    userRoles.includes(duplicateUserRole)
  ) {
    sideItemsClient.splice(1, 0, {
      href: "/professional-view",
      title: "Advisor Panel",
      image: dashboard,
      whiteImage: dashboardwhite,
      permission: [
        "Financial Advisor",
        "Super Admin",
        "create financial advisor client",
      ],
    });
  }

  return sideItemsClient;
};
export const sideItemsProfile = [
  {
    href: "/profilePage",
    title: "Profile Settings",
    image: userImg,
    whiteImage: userImg,
    // whiteImage: userwhiteImg,
    permission: [
      "Super Admin",
      "Update Profile Settings",
      "Get Profile Settings",
    ],
  },
  {
    href: "/manage-owners",
    title: "Owners & Entities",
    image: owners,
    whiteImage: owners,
    permission: [
      "Super Admin",
      "create client module",
    ],
  },
  {
    href: "/subscription",
    title: "Subscription",
    image: subscribeImg,
    whiteImage: subscribeImg,
    // whiteImage: subscribewhiteImg,
    permission: ["Super Admin", "Get Client Stripe Sub List"],
  },
  {
    href: "/delgateAccess",
    title: "Delegate Access",
    image: deletgateAccessSettings,
    whiteImage: deletgateAccessSettings,
    // whiteImage: deletgateAccessSettingsWhite,
    permission: ["Super Admin", "Get Cleint List For Delegation Access"],
  },
  {
    href: "/questioner",
    title: "Profile Questionnaire",
    image: clientcustom,
    whiteImage: clientcustom,
    // whiteImage: deletgateAccessSettingsWhite,
    permission: ["Super Admin", "Get Cleint List For Delegation Access"],
  },
  // {
  //   href: "",
  //   title: "Payment",
  //   image: payemntImg,
  //   whiteImage: payemntwhiteImg,
  //   permission: ["Super Admin"],
  // },
  {
    href: "/rewards",
    title: "Rewards",
    image: rewardImg,
    whiteImage: rewardImg,
    // whiteImage: rewardwhiteImg,
    permission: ["Super Admin", "Send Email For Invite"],
  },
  // {
  //   href: "",
  //   title: "Notification (39)",
  //   image: notificationImg,
  //   whiteImage: notificationwhiteImg,
  //   permission: ["Super Admin"],
  // },
  // {
  //   href: "",
  //   title: "Privacy and Security",
  //   image: secureImg,
  //   whiteImage: securewhiteImg,
  //   permission: ["Super Admin"],
  // },
  // {
  //   href: "/plaid",
  //   title: "Link Bank",
  //   image: clienttax,
  //   whiteImage: clienttaxwhite,
  //   permission: [
  //     "Store Account Details",
  //     "Super Admin",
  //   ],
  // },
  {
    href: "/settings",
    title: "Setting",
    image: settingImg,
    whiteImage: settingImg,
    // whiteImage: settingwhiteImg,
    permission: ["Super Admin"],
  },
];

export const restrictedTrusteeTabs = [
  "Dashboard",
  "Client Information",
  "Client Contacts",
  "Tax and Inflation",
  "Rates of Return",
  "Organizer",
  "Assets",
  "Liabilities and Credit",
  "Insurance",
  "Sources of Income",
  "Budget",
  "Important Document",
  "Planner",
  "Debt Payoff",
  "Social Security",
  "Goals",
  "Disability",
  "Divorce",
  "Disaster",
  "Reports",
  "Manage Secure Links",
  "Link Bank",
  "Chat",
  "FAQ Help Support",
  "Feedback",

  // sideItemsProfile
  "Profile Settings",
  "Owners & Entities",
  "Subscription",
  "Profile Questionnaire",
  "Rewards",
  "Setting"
];
